import { render, staticRenderFns } from "./FindTalents.vue?vue&type=template&id=6dd5cabc&"
import script from "./FindTalents.vue?vue&type=script&lang=js&"
export * from "./FindTalents.vue?vue&type=script&lang=js&"
import style0 from "./FindTalents.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports